import { useEffect, useState } from "react";

export const useAuth = () => {
  const UserDetails = sessionStorage.getItem("UserData");
  const [token, setToken] = useState(
    () => sessionStorage.getItem("token")
  );

  const isSignedIn = !!token;

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(sessionStorage.getItem("token"));
    };
    window.addEventListener("auth-change", handleStorageChange);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("auth-change", handleStorageChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return {
    isSignedIn,
    token,
    UserDetails,
  };
};
